const resources = {
  en: {
    repaymentPlans: {
      actions: {
        open: 'Payment plan',
        create: 'Create plan',
        cancel: 'Cancel',
        cancelPlan: 'Cancel plan',
      },
      status: {
        active: 'Plan active',
        draft: 'Plan draft',
        paused: 'Plan paused',
        completed: 'Plan completed',
        cancelled: 'Plan cancelled',
      },
      form: {
        debtTitle: 'Create payment plan',
        creditTitle: 'Create credit card repayment plan',
        obligationTitle: 'Create obligation payoff plan',
        intro: 'This creates auto-generated payment tasks one month ahead. Confirming a task is still the action that records the real payment.',
        sourceAccount: 'Funding account',
        sourceAccountPlaceholder: 'Select funding account',
        strategy: 'Strategy',
        fixedAmount: 'Fixed amount',
        minimumPayment: 'Minimum payment',
        minimumPlusPercent: 'Minimum + acceleration',
        amount: 'Payment amount',
        minimumPaymentAmount: 'Minimum payment',
        extraPercent: 'Extra over minimum',
        extraPercentPlaceholder: 'For example 50 for +50%',
        cadence: 'Cadence',
        cadenceWeekly: 'Weekly',
        cadenceBiweekly: 'Bi-weekly',
        cadenceMonthly: 'Monthly',
        paymentDay: 'Payment day',
        startDate: 'Start date',
        amountHint: 'Decimals are supported. Use a dot, for example: 75.00',
        targetSnapshot: 'Target',
        required: 'Required',
      },
      messages: {
        created: 'Repayment plan created',
        createError: 'Unable to create repayment plan: {{error}}',
        cancelled: 'Repayment plan cancelled',
        cancelError: 'Unable to cancel repayment plan: {{error}}',
        loadError: 'Unable to load repayment plans',
      },
      cancel: {
        confirmTitle: 'Cancel this repayment plan?',
        confirmDescription: 'Future scheduled installments from this plan will stop. Existing completed payments and ledger history will stay unchanged.',
        confirm: 'Confirm cancellation',
      },
      progress: {
        title: 'Plan progress',
        onTrack: 'On track',
        needsAttention: 'Needs attention',
        score: 'Score {{score}}',
        progressAria: 'Repayment plan progress',
        paid: 'Paid',
        nextDue: 'Next',
        noNextDue: 'No generated task yet',
        setupPending: 'Setup pending',
        plannedPayment: 'Planned payment',
        outstanding: 'Outstanding',
        waitingForTasks: 'Waiting for scheduled tasks',
        overdue: '{{count}} overdue',
        late: '{{count}} late',
      },
    },
  },
  uk: {
    repaymentPlans: {
      actions: {
        open: 'План платежів',
        create: 'Створити план',
        cancel: 'Скасувати',
        cancelPlan: 'Скасувати план',
      },
      status: {
        active: 'План активний',
        draft: 'План чернетка',
        paused: 'План на паузі',
        completed: 'План завершено',
        cancelled: 'План скасовано',
      },
      form: {
        debtTitle: 'Створити план платежів',
        creditTitle: 'Створити план погашення кредитки',
        obligationTitle: 'Створити план погашення зобовʼязання',
        intro: 'План створює автоматичні задачі на місяць вперед. Реальний платіж у ledger зʼявляється тільки після підтвердження задачі.',
        sourceAccount: 'Рахунок для оплати',
        sourceAccountPlaceholder: 'Оберіть рахунок для оплати',
        strategy: 'Стратегія',
        fixedAmount: 'Фіксована сума',
        minimumPayment: 'Мінімальний платіж',
        minimumPlusPercent: 'Мінімальний + прискорення',
        amount: 'Сума платежу',
        minimumPaymentAmount: 'Мінімальний платіж',
        extraPercent: 'Додатково понад мінімум',
        extraPercentPlaceholder: 'Наприклад 50 для +50%',
        cadence: 'Ритм',
        cadenceWeekly: 'Щотижня',
        cadenceBiweekly: 'Раз на два тижні',
        cadenceMonthly: 'Щомісяця',
        paymentDay: 'День платежу',
        startDate: 'Дата старту',
        amountHint: 'Дробова частина підтримується. Використовуйте крапку, наприклад: 75.00',
        targetSnapshot: 'Ціль',
        required: 'Обовʼязково',
      },
      messages: {
        created: 'План платежів створено',
        createError: 'Не вдалося створити план платежів: {{error}}',
        cancelled: 'План платежів скасовано',
        cancelError: 'Не вдалося скасувати план платежів: {{error}}',
        loadError: 'Не вдалося завантажити плани платежів',
      },
      cancel: {
        confirmTitle: 'Скасувати цей план платежів?',
        confirmDescription: 'Майбутні задачі з цього плану більше не створюватимуться. Уже підтверджені платежі та історія ledger не зміняться.',
        confirm: 'Підтвердити скасування',
      },
      progress: {
        title: 'Прогрес плану',
        onTrack: 'За планом',
        needsAttention: 'Потребує уваги',
        score: 'Оцінка {{score}}',
        progressAria: 'Прогрес плану платежів',
        paid: 'Сплачено',
        nextDue: 'Наступна',
        noNextDue: 'Задача ще не створена',
        setupPending: 'Очікує генерації',
        plannedPayment: 'Плановий платіж',
        outstanding: 'Залишок',
        waitingForTasks: 'Очікує створення задач',
        overdue: 'Прострочено: {{count}}',
        late: 'Запізнення: {{count}}',
      },
    },
  },
}

export default resources
